import { render, staticRenderFns } from "./TheFarmacia.vue?vue&type=template&id=3852b2b3&"
import script from "./TheFarmacia.vue?vue&type=script&lang=js&"
export * from "./TheFarmacia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports